import { gql } from '../gql';
import { routecrumbFragment, productMetadataFragment } from '@jetshop/core/data/fragments';
import logWarningInDev from '../helpers/logWarningInDev';
logWarningInDev(true, `The queries in '@jetshop/core/data/queries' have been deprecated and should not be used. To give you more flexibility we have moved query composition into the shop, so your queries should be there instead.`);
export const productQuery = (name, fragment) => {
    logWarningInDev(true, `productQuery is deprecated and will be removed in the next major release. Put the query in your shop repository instead.`);
    return gql `
    query ${name}($articleNumber: String = null, $id: Int = null) {
      product(articleNumber: $articleNumber, id: $id) {
        id
        ${fragment}
        ${productMetadataFragment}
      }
    }
  `;
};
export const productsQuery = (name, fragment) => {
    logWarningInDev(true, `productsQuery is deprecated and will be removed in the next major release. Put the query in your shop repository instead.`);
    return gql `
  query ${name}(
    $first: Paging = 16
  ) {
    search(term: "") {
      products (
        paging: {first: $first}
      ) {
        totalResults
        result {
          id
          ${fragment}
        }
      }
    }
  }
`;
};
export const categoriesQuery = (name, fragment) => {
    logWarningInDev(true, `categoriesQuery is deprecated and will be removed in the next major release. Put the query in your shop repository instead.`);
    return gql `
    query ${name}($root: Int, $levels: Int, $includeHidden: Boolean) {
      categories(root: $root, levels: $levels, includeHidden: $includeHidden) {
        id
        ${fragment}
      }
    }
  `;
};
export const categoryQuery = (name, fragment) => {
    logWarningInDev(true, `categoryQuery is deprecated and will be removed in the next major release. Put the query in your shop repository instead.`);
    return gql `
    query ${name}(
    $id: Int!,
    $first: Paging = 16,
    $offset: Int = 0,
    $filters: FilterInput,
    $orderBy: ProductOrderOptions,
    $orderByDirection: SortDirection
  ) {
      category(id: $id) {
        id
        ${fragment}
      }
    }
  `;
};
export const storeQuery = (name, fragment) => {
    logWarningInDev(true, `storeQuery is deprecated and will be removed in the next major release. Put the query in your shop repository instead.`);
    return gql `
    query ${name}($id: Int!) {
      store(id: $id) {
        id
        ${fragment}
      }
    }
  `;
};
export const deprecatedRouteQuery = (productFragment, categoryFragment, contentFragment) => {
    logWarningInDev(true, `Passing fragments to DynamicRoute is deprecated and will be removed in the next major version. Create a file called 'src/components/RouteQuery.gql' and paste the contents from this url: https://gitlab.jetshop.se/jetshop/flight/blob/master/packages/template-trend/src/components/RouteQuery.gql`);
    return gql `
  query route(
    $path: String!
    $first: Paging = 16
    $offset: Int = 0,
    $orderBy: ProductOrderOptions,
    $orderByDirection: SortDirection,
    $filters: FilterInput
  ) {
    route(path: $path) {
      ${routecrumbFragment}
      object {
        breadcrumbText
        head {
          title
          metaTags {
            name
            content
          }
        }
        ${categoryFragment}
        ${productFragment}
        ${contentFragment}
        ${productMetadataFragment}
      }
    }
  }
`;
};
export const channelsQuery = gql `
  query ChannelsQuery {
    channels {
      id
      name
      url
      isDefault
      displayName
      url
      imageUrl
      countries {
        name
        code
        isDefault
      }
      languages {
        culture
        name
        isDefault
      }
      currencies {
        id
        name
        isDefault
        format {
          code
          culture
          decimals
        }
      }
      defaultCurrency {
        id
        name
        isDefault
        format {
          code
          culture
          decimals
        }
      }
      defaultLanguage {
        culture
        name
        isDefault
      }
      settings {
        tracking {
          ga {
            trackingId
          }
          gtm {
            containerId
          }
        }
        countrySettings {
          countryCode
          paymentTypes {
            name
            apiClientId
            availableForPrivate
            availableForBusiness
          }
          shipping {
            freeShippingLimit {
              incVat
              exVat
            }
          }
        }
        pricesIncVat
      }
    }
  }
`;
export const pagesQuery = gql `
  query PagesQuery {
    pages {
      name
      id
      primaryRoute {
        id
        path
      }
    }
  }
`;
export const startPageQuery = (productFragment) => {
    logWarningInDev(true, `Using the startPageQuery from core is deprecated and will not work in the next major release.`);
    return gql `
    query StartPageQuery ($startPageId: Int) {
      startPage(id: $startPageId) {
        head {
          title
          metaTags {
            name
            content
          }
        }
        isActive
        breadcrumbText
        name
        content
        images {
          url
          width
          title
          height
        }
        items {
          row
          column
          id
          item {
            ... on Product {
              ${productFragment}
            }
            ... on CustomItem {
              name
              linkUrl
              content
              image {
                url
                title
                width
                height
              }
            }
          }
        }
      }
    }
  `;
};
//# sourceMappingURL=queries.js.map